<template>
  <div>
    <b-modal hide-footer no-close-on-backdrop v-model="modalShow" size="lg" :title="'Conductor a autorizar: '+driver.firstName + ' ' + driver.lastName ">
      <div class="modal-body">
        <b-row>
          <b-col md="12" class="my-1">
            <!-- <b-alert v-if="errorAuthorized" show variant="danger">{{ errorAuthorized }}</b-alert> -->
            <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
              <b-input-group>
                <b-form-input v-model="filter" @input="findNotAllowedConcesionesByConcesionarioIdAndDriverId()" class="form-control" placeholder="Buscar concesión"></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-table
              show-empty
              stacked="md"
              :items="vehiculos"
              :fields="fields"
              :current-page="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
              empty-text="No existen registros por mostrar"
              emptyFilteredText="No existen registros por mostrar"
            >
              <template v-slot:cell(acciones)="row">
                <b-button class="btn-sm" :disabled="autorizando" variant="outline-info" @click="authorizeConcessionDriver({data: row.item})">Autorizar</b-button>
              </template>
            </b-table>
          </b-col>
          <b-col md="12" class="my-1">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              align="right"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
        <div class="text-center" v-if="autorizando">
          <b-spinner variant="info" label="Spinning">Cargando</b-spinner>
        </div>
      </div>
    </b-modal>
    <h1 >Actualizar Concesionario</h1>
      <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="row">
      <div class="col-md-5">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-4"></h5>
            <a-form :form="form" @submit.prevent="addConcesionario()" layout="vertical">
              <b-row>
                <b-col md="12">
                  <a-form-item label="Nombre del concesionario">
                    <a-input
                      placeholder="Nombre del concesionario"
                      v-model="$v.getConcesionarioId.name.$model"
                    />
                    <small
                      class="text-danger"
                      v-if="!$v.getConcesionarioId.name.required"
                      >Campo requerido. No debe estar vacío.</small
                    >
                  </a-form-item>
                  <a-form-item label="Correo electrónico">
                    <a-input placeholder="Correo electrónico" v-model="$v.getConcesionarioId.email.$model" />
                    <small class="text-danger" v-if="!$v.getConcesionarioId.email.required">Campo requerido. No debe estar vacío.</small><br>
                    <small class="text-danger" v-if="!$v.getConcesionarioId.email.email">El correo electrónico no es válido, no debe contener espacios. Vuelve a intentarlo.</small><br>
                    <small class="text-danger" v-if="!validateRegisteredEmail($v.getConcesionarioId.email.$model)">Este correo electrónico ya ha sido registrado previamente. Intenta con uno diferente.</small>
                  </a-form-item>
                  <a-form-item label="Número de teléfono">
                    <a-input
                      placeholder="Número de teléfono"
                      v-model="$v.getConcesionarioId.phoneNumber.$model"
                    />
                    <small class="text-danger" v-if="!$v.getConcesionarioId.phoneNumber.required">Campo requerido. No debe estar vacío</small><br>
                    <small class="text-danger" v-if="!$v.getConcesionarioId.phoneNumber.phoneNumber">El número de teléfono no es válido, no debe contener espacios. Vuelve a intentarlo.</small><br>
                    <small class="text-danger" v-if="!validateRegisteredPhone($v.getConcesionarioId.phoneNumber.$model)">Este número de telefono ya ha sido registrado previamente. Intenta con uno diferente.</small>
                  </a-form-item>
                  <a-form-item label="Estado">
                    <v-select :options="Object.values(estados)" @input="handleEstadoChange" @select="handleEstadoChange" v-model="$v.getConcesionarioId.address.state.$model"><span slot="no-options">Campo requerido. No debe estar vacío.</span></v-select>
                      <small class="text-danger" v-if="!$v.getConcesionarioId.address.state.required">Campo requerido. No debe estar vacío.</small>
                  </a-form-item>
                  <a-form-item label="Municipio">
                    <v-select :options="Object.keys(municipios)" @input="handleMunicipioChange" @select="handleMunicipioChange" v-model="$v.getConcesionarioId.address.city.$model"><span slot="no-options">Campo requerido. No debe estar vacío.</span></v-select>
                    <small class="text-danger" v-if="!$v.getConcesionarioId.address.city.required">Campo requerido. No debe estar vacío.</small>
                  </a-form-item>
                  <a-form-item label="Código Postal">
                    <v-select :options="Object.keys(codigos)" @input="handleCodigoChange" @select="handleCodigoChange" v-model="$v.getConcesionarioId.address.postalCode.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                      <small class="text-danger" v-if="!$v.getConcesionarioId.address.postalCode.required">Campo requerido. No debe estar vacío.</small><br>
                      <small class="text-danger" v-if="!$v.getConcesionarioId.address.postalCode.numeric">Ingresa un código postal válido</small>
                  </a-form-item>
                  <a-form-item label="Colonia">
                    <v-select :options="Object.values(colonias)" v-model="$v.getConcesionarioId.address.suburb.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                      <small class="text-danger" v-if="!$v.getConcesionarioId.address.suburb.required">Campo requerido. No debe estar vacío.</small>
                  </a-form-item>
                  <a-form-item label="Número exterior">
                    <a-input
                      placeholder="Número exterior"
                      v-model="$v.getConcesionarioId.address.extNumber.$model"/>
                      <small class="text-danger" v-if="!$v.getConcesionarioId.address.extNumber.required">Campo requerido. No debe estar vacío.</small><br>
                      <small class="text-danger" v-if="!$v.getConcesionarioId.address.extNumber.alphaNum">Ingresa un número exterior válido</small>
                  </a-form-item>
                  <a-form-item label="Número interior">
                    <a-input
                      placeholder="Número interior"
                      v-model="$v.getConcesionarioId.address.intNumber.$model"/>
                      <small class="text-danger" v-if="!$v.getConcesionarioId.address.intNumber.alphaNum">Ingresa un número interior válido</small>
                  </a-form-item>
                  <a-form-item label="Calle">
                    <a-input
                      placeholder="Calle"
                      v-model="$v.getConcesionarioId.address.street.$model"/>
                      <small class="text-danger" v-if="!$v.getConcesionarioId.address.street.required">Campo requerido. No debe estar vacío.</small>
                  </a-form-item>
                  <a-form-item label="Preferente">
                    <a-checkbox v-model="preferential">
                      Preferente
                    </a-checkbox>
                  </a-form-item>
                  <template v-if="preferential == 0">
                    <p id="deshabilitado">Se encuentra deshabilitado el campo de preferente</p>
                  </template>
                  <template v-else></template>
                  <a-form-item>
                    <button
                    :disabled="!(validateRegisteredEmail($v.getConcesionarioId.email.$model) && validateRegisteredPhone($v.getConcesionarioId.phoneNumber.$model) && validateRegisteredRFC($v.getConcesionarioId.rfc.$model) && !$v.$invalid)"
                      type="submit"
                      class="btn btn-success px-5"
                    >
                      Guardar
                    </button>
                  </a-form-item>
                </b-col>
              </b-row>
            </a-form>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col md="6" class="my-1 text-end">
                <b-form-group class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="cardIdDriver" @input="getDriverByCardId()" class="form-control" placeholder="Buscar número de tarjetón"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!cardIdDriver" @click="cardIdDriver = ''">Limpiar</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6" class="text-right">
                <span v-if="checkedAuth">Desautorizados</span>
                <span v-if="!checkedAuth">Autorizados</span>
                <b-form-checkbox v-model="checkedAuth" v-on:change="toggleDrivers(checkedAuth)" name="check-button" switch></b-form-checkbox>
              </b-col>
              <b-col md="12" v-if="cardIdDriver">
                <hr>
                <b-row align-v="center">
                  <b-col sm="4">{{driver.firstName}}</b-col>
                  <b-col sm="4">{{driver.lastName}}</b-col>
                  <b-col sm="4">
                    <b-button
                      class="btn-sm"
                      variant="outline-info"
                      @click="modalShow=!modalShow"
                    >
                      Autorizar
                    </b-button>
                  </b-col>
                </b-row>
                <hr>
              </b-col>
              <b-col md="12" class="mt-4" v-if="checkedAuth">
                <b-table
                  show-empty
                  stacked="md"
                  :fields="concesionFields"
                  :items="concesiones"
                  :sort-by.sync="sortByAuthorized"
                  :sort-desc.sync="sortDescAuthorized"
                  :sort-direction="sortDirectionAuthorized"
                  empty-text="No existen registros por mostrar"
                  emptyFilteredText="No existen registros por mostrar"
                  >
                  <template v-slot:cell(accionesAuthorized)="row">
                    <b-button v-if="row.item.authorize == 1" class="btn-sm" variant="outline-danger" @click="unAuthorizeConcessionDriver({data: row.item})">Desautorizar</b-button>
                  </template>
                </b-table>
                <div class="text-center" v-if="$apollo.queries.getConcesionDriverByConcesionarioId.loading">
                  <b-spinner variant="info" label="Spinning">Cargando</b-spinner>
                </div>
              </b-col>
              <b-col md="12" class="mt-3" v-if="!checkedAuth">
                <b-table
                  show-empty
                  stacked="md"
                  :items="unauthorizedDrivers"
                  :fields="concesionFields"
                  empty-text="No existen registros por mostrar"
                >
                <template v-slot:cell(accionesAuthorized)="row">
                    <b-button
                      class="btn-sm"
                      variant="outline-info"
                      @click="AuthorizeConcessionDriverAgain({data: row.item})"
                    >Autorizar
                    </b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { required, helpers, alphaNum, numeric } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
//
const phoneNumber = helpers.regex('phone', /^[0-9]{10}$/)
const rfc = helpers.regex('rfc', /^([A-ZÑ&]{3,4})+?(?:-?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))+?(?:-?)?([A-Z\d]{2})([A-Z\d])$/)
const email = helpers.regex('email', /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/)
const GET_DRIVER_BY_CARD_ID = gql`
  query getDriverByCardId ($cardId: String!) {
    getDriverByCardId (cardId: $cardId){
      id
      firstName
      lastName
    }
  }
`
const GET_CONCESION_DRIVER_BY_CONCESIONARIO_ID = gql`
  query getConcesionDriverByConcesionarioId ($concesionarioId: Int!) {
    getConcesionDriverByConcesionarioId (concesionarioId: $concesionarioId){
      driver {
        id
        cardId
        firstName
        lastName
        license
      }
      concesion {
        id
        concesionNumber
      }
      authorize
    }
  }
`
const GET_NOT_ALLOWED_CONCESIONES_BY_CONSESIONARIO_ID_AND_DRIVER_ID = gql`
  query getNotAllowedConcesionesByConcesionarioIdAndDriverId ($concesionarioId: Int!, $driverId: Int!) {
    getNotAllowedConcesionesByConcesionarioIdAndDriverId (concesionarioId: $concesionarioId, driverId: $driverId) {
      id
      concesionNumber
      concesionario {
        id
        name
        rfc
      }
      vehicle {
        id
        brand
        licensePlate
        model
        serialNumber
      }
      active
    }
  }
`
const RESTRICT_CONCESION_DRIVER = gql`
  mutation restrictConcesionDriver($driverId: Int, $concesionId: Int) {
    restrictConcesionDriver(driverId: $driverId, concesionId: $concesionId) {
      authorize
    }
  }
`
const GET_NOT_ALLOWED_DRIVERS = gql`
  query getNotallowedDrivers ($concesionarioId: Int!) {
    getNotallowedDrivers (concesionarioId: $concesionarioId){
      driver {
        id
        cardId
        firstName
        lastName
        license
      }
      concesion {
        id
        concesionNumber
      }
      authorize
    }
  }
`
const UPDATE_CONCESIONARIO = gql`
  mutation updateConcesionario($idEdit: Int, $name: String, $email: String, $phoneNumber: String, $rfc: String, $tripsAvailable: Int, $city: String, $extNumber: String, $intNumber: String, $postalCode: String, $state: String, $suburb: String, $street: String, $preferential: Int) {
    updateConcesionario(id: $idEdit, concesionario: {
      name: $name
      email: $email
      phoneNumber: $phoneNumber
      rfc: $rfc
      tripsAvailable: $tripsAvailable
      preferential: $preferential
      address: {
        city: $city
        extNumber: $extNumber
        intNumber: $intNumber
        postalCode: $postalCode
        state: $state
        suburb: $suburb
        street: $street
      }
    }) {
      name
      email
      phoneNumber
      rfc
      tripsAvailable
      preferential
      address {
        city
        extNumber
        intNumber
        postalCode
        state
        suburb
        street
      }
    }
  }
`
const UPDATE_DRIVER_AUTHORIZE_ALLOWED = gql`
  mutation updateDriverauthorizeallowed($driverId: Int, $concesionId: Int) {
    updateDriverauthorizeallowed(driverId: $driverId, concesionId: $concesionId) {
      message
    }
  }
`
const AUTHORIZE_CONCESION_DRIVER = gql`
  mutation authorizeConcesionDriver($driverId: Int, $concesionId: Int) {
    authorizeConcesionDriver(
      concesionDriver: {
        driverId: $driverId
        concesionId: $concesionId
      }) {
    authorize
    }
  }
`
console.log('GET_CONCESION_DRIVER_BY_CONCESIONARIO_ID')
console.log(GET_CONCESION_DRIVER_BY_CONCESIONARIO_ID)
export default {
  data: function () {
    return {
      disabledButton: false,
      error: null,
      id: this.$route.params.id,
      form: this.$form.createForm(this),
      preferential: false,
      pref: 0,
      getConcesionarioId: {
        name: this.$route.params.name,
        email: this.$route.params.email,
        phoneNumber: this.$route.params.phoneNumber?.replace('+52', ''),
        rfc: this.$route.params.rfc,
        address: {
          city: this.$route.params.address.city,
          extNumber: this.$route.params.address.extNumber,
          intNumber: this.$route.params.address.intNumber,
          postalCode: this.$route.params.address.postalCode,
          state: this.$route.params.address.state,
          suburb: this.$route.params.address.suburb,
          street: this.$route.params.address.street,
        },
        tripsAvailable: 0,
      },
      fields: [
        { key: 'concesionNumber', label: 'Concesión' },
        { key: 'vehicle.model', label: 'Modelo Vehículo' },
        { key: 'vehicle.licensePlate', label: 'Placa del vehículo' },
        { key: 'acciones', label: 'Acciones' },
      ],
      concesionFields: [
        { key: 'concesion.concesionNumber', label: 'Concesion', sortable: true },
        { key: 'driver.firstName', label: 'Nombre', sortable: true },
        { key: 'driver.lastName', label: 'Apellido', sortable: true },
        { key: 'driver.license', label: 'Licencia', sortable: true },
        { key: 'driver.cardId', label: 'Tarjetón', sortable: true },
        { key: 'accionesAuthorized', label: 'Acciones' },
      ],
      fieldsAuthorized: [
        { key: 'driver.cardId', label: 'Número de tarjetón', sortable: true, sortDirection: 'desc' },
        { key: 'driver.firstName', label: 'Nombre' },
        { key: 'driver.lastName', label: 'Apellidos' },
        { key: 'driver.license', label: 'Número de licencia' },
        { key: 'concesion.concesionNumber', label: 'Concesión autorizada' },
        { key: 'accionesAuthorized', label: 'Acciones' },
      ],
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredRFC: {},
      registeredPhone: {},
      registeredEmail: {},
      cardIdDriver: '',
      driver: {
        firstName: '',
        lastName: '',
        id: 0,
      },
      concesiones: [],
      unauthorizedDrivers: [],
      vehiculos: [],
      estados: ['Ciudad de México', 'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
        'Coahuila de Zaragoza', 'Colima', 'Chiapas', 'Chihuahua', 'Durango', 'Guanajuato', 'Guerrero',
        'Hidalgo', 'Jalisco', 'México', 'Michoacán de Ocampo', 'Morelos', 'Nayarit', 'Nuevo León',
        'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
        'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz de Ignacio de la Llave', 'Yucatán', 'Zacatecas'],
      municipios: [],
      codigos: [],
      colonias: [],
      data: {},
      modalShow: false,
      totalRows: 1,
      totalRowsAuthorized: 1,
      totalRowsUnAuthorized: 1,
      currentPage: 1,
      currentPageAuthorized: 1,
      currentPageUnAuthorized: 1,
      perPage: 10,
      perPageAuthorized: 10,
      perPageUnAuthorized: 10,
      pageOptions: [5, 10, 15],
      pageOptionsAuthorized: [5, 10, 15],
      pageOptionsUnAuthorized: [5, 10, 15],
      sortBy: null,
      sortByAuthorized: null,
      sortByUnAuthorized: null,
      sortDesc: false,
      sortDescAuthorized: false,
      sortDescUnAuthorized: false,
      sortDirection: 'asc',
      sortDirectionAuthorized: 'asc',
      sortDirectionUnAuthorized: 'asc',
      filter: null,
      filterAuthorized: null,
      filterUnAuthorized: null,
      autorizando: false,
      errorAuthorized: null,
      confirmAuth: false,
      messageAuth: '',
      checkedAuth: true,
    }
  },
  apollo: {
    getConcesionDriverByConcesionarioId: {
      query: GET_CONCESION_DRIVER_BY_CONCESIONARIO_ID,
      context: headers(),
      variables() {
        return {
          concesionarioId: this.$route.params.id,
        }
      },
      error (err) {
        console.log('Error en query getConcesionDriverByConcesionarioId')
        console.log(err)
      },
      result ({ data, loading, networkStatus }) {
        console.log('Result getConcesionDriverByConcesionarioId')
        console.log(data)
        this.concesiones = data.getConcesionDriverByConcesionarioId
      },
    },
  },
  methods: {
    async addConcesionario() {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      this.pref = this.preferential === true ? 1 : 0
      await this.$apollo.mutate({
        mutation: UPDATE_CONCESIONARIO,
        context: headers(),
        variables: {
          idEdit: parseInt(this.id),
          name: this.getConcesionarioId.name,
          email: this.getConcesionarioId.email.trim(),
          phoneNumber: '+52' + this.getConcesionarioId.phoneNumber,
          rfc: this.getConcesionarioId.rfc.trim(),
          city: this.getConcesionarioId.address.city,
          extNumber: this.getConcesionarioId.address.extNumber,
          intNumber: this.getConcesionarioId.address.intNumber,
          postalCode: this.getConcesionarioId.address.postalCode,
          state: this.getConcesionarioId.address.state,
          suburb: this.getConcesionarioId.address.suburb,
          street: this.getConcesionarioId.address.street,
          preferential: this.pref,
          tripsAvailable: 0, // parseInt(this.getConcesionarioId.tripsAvailable),
        },
      })
        .then(res => {
          this.$router.push('/concesionarios/getFranchises')
        })
        .catch(error => {
          this.disabledButton = false
          console.log(error)
          this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
          this.mensaje.color = 'warning'
          this.showAlert()
        })
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onFilteredAuthorized(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsAuthorized = filteredItems.length
      this.currentPageAuthorized = 1
    },
    onFilteredUnAuthorized(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRowsUnAuthorized = filteredItems.length
      this.currentPageUnAuthorized = 1
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    validateRegisteredPhone(phone) {
      if (this.registeredPhone['+52' + phone]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredRFC(rfc) {
      if (this.registeredRFC[rfc.trim()]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredEmail(email) {
      if (this.registeredEmail[email.trim()]) {
        return false
      } else {
        return true
      }
    },
    handleEstadoChange(estado) {
      if (estado === null) {
        this.municipios = []
        this.colonias = []
        this.codigos = []
        this.getConcesionarioId.address.city = ''
        this.getConcesionarioId.address.suburb = ''
        this.getConcesionarioId.address.postalCode = ''
      } else {
        this.data = require(`../../../services/data/${estado}.json`)
        this.municipios = this.data[estado]
        this.colonias = []
        this.codigos = []
        this.getConcesionarioId.address.city = ''
        this.getConcesionarioId.address.suburb = ''
        this.getConcesionarioId.address.postalCode = ''
      }
    },
    handleMunicipioChange(municipio) {
      if (municipio === null) {
        this.codigos = []
        this.colonias = []
        this.getConcesionarioId.address.suburb = ''
        this.getConcesionarioId.address.postalCode = ''
      } else {
        this.colonias = []
        this.codigos = this.data[this.getConcesionarioId.address.state][municipio]
        this.getConcesionarioId.address.suburb = ''
        this.getConcesionarioId.address.postalCode = ''
      }
    },
    handleCodigoChange(codigo) {
      if (codigo === null) {
        this.colonias = []
        this.getConcesionarioId.address.suburb = ''
      } else {
        this.colonias = this.data[this.getConcesionarioId.address.state][this.getConcesionarioId.address.city][codigo]
        this.getConcesionarioId.address.suburb = ''
      }
    },
    getDriverByCardId() {
      this.$apollo.query({
        query: GET_DRIVER_BY_CARD_ID,
        context: headers(),
        variables: {
          cardId: this.cardIdDriver,
        },
      })
        .then(({ data }) => {
          // console.log('DATA getDriverByCardId =======>')
          // console.log(data)
          this.driver = data.getDriverByCardId
        })
        .catch(error => {
          console.log(error)
        })
    },
    toggleDrivers(checkedAuth) {
      if (!checkedAuth) {
        this.findNotAllowedConcesionesByConcesionarioIdAndDriverId()
      } else {
        this.getNotallowedDrivers()
      }
    },
    findNotAllowedConcesionesByConcesionarioIdAndDriverId() {
      console.log('getNotAllowedConcesionesByConcesionarioIdAndDriverId ======')
      this.$apollo.query({
        query: GET_NOT_ALLOWED_CONCESIONES_BY_CONSESIONARIO_ID_AND_DRIVER_ID,
        context: headers(),
        variables: {
          concesionarioId: this.id, driverId: parseInt(this.driver.id),
        },
      })
        .then(({ data }) => {
          console.log('RESULT')
          console.log(data)
          if (data.getNotAllowedConcesionesByConcesionarioIdAndDriverId) {
            this.vehiculos = data.getNotAllowedConcesionesByConcesionarioIdAndDriverId
            this.totalRows = data.getNotAllowedConcesionesByConcesionarioIdAndDriverId.length
          }
        })
        .catch((err) => {
          console.log('ERROR')
          console.log(err)
        })
    },
    getNotallowedDrivers() {
      console.log('getNotallowedDrivers')
      this.$apollo.query({
        query: GET_NOT_ALLOWED_DRIVERS,
        context: headers(),
        variables: {
          concesionarioId: this.id,
        },
      })
        .then(({ data }) => {
          this.unauthorizedDrivers = data.getNotallowedDrivers
          // this.totalRows = data.getNotAllowedDrivers.length
        })
        .catch((err) => {
          console.log('ERROR')
          console.log(err)
        })
    },
    async unAuthorizeConcessionDriver(disable) {
      console.log(disable.data.driver.id)
      console.log(disable.data.concesion.id)
      await this.reloadDataDrivers()
      await this.$apollo.mutate({
        mutation: RESTRICT_CONCESION_DRIVER,
        context: headers(),
        variables: {
          driverId: parseInt(disable.data.driver.id),
          concesionId: parseInt(disable.data.concesion.id),
        },
      })
        .then(res => {
          this.makeToast(true, 'success', 'Desautorización correcta', 'Conductor desautorizado correctamente.')
          this.confirmAuth = true
          this.dataLoad = parseInt(this.getFranchisee)
          // this.$apollo.queries.getNotAllowedConcesionesByConcesionarioIdAndDriverId.refetch()
        })
        .catch(error => {
          if (error) {
            this.dataLoad = parseInt(this.getFranchisee)
            this.makeToast(true, 'danger', 'error', 'Ocurrió un error, Inténtalo de nuevo.')
          }
        })
    },
    async AuthorizeConcessionDriverAgain(authAgain) {
      // console.log(authAgain.data.concesion.id)
      // console.log(authAgain.data.driver.id)
      await this.reloadDataDrivers()
      await this.$apollo.mutate({
        mutation: UPDATE_DRIVER_AUTHORIZE_ALLOWED,
        context: headers(),
        variables: {
          driverId: parseInt(authAgain.data.driver.id),
          concesionId: parseInt(authAgain.data.concesion.id),
        },
      })
        .then(res => {
          this.makeToast(true, 'success', 'Autorización correcta', 'Conductor autorizado correctamente.')
          this.confirmAuth = true
          this.dataLoad = parseInt(this.getFranchisee)
        })
        .catch(error => {
          if (error) {
            this.dataLoad = parseInt(this.getFranchisee)
            this.makeToast(true, 'danger', 'error', 'Ocurrió un error, Inténtalo de nuevo.')
          }
        })
    },
    async authorizeConcessionDriver(auth) {
      // console.log(data.franchisee)
      this.autorizando = true
      await this.reloadDataDrivers()
      await this.$apollo.mutate({
        mutation: AUTHORIZE_CONCESION_DRIVER,
        context: headers(),
        variables: {
          driverId: parseInt(this.driver.id),
          concesionId: parseInt(auth.data.id),
        },
      })
        .then(res => {
          // this.modalShow = false
          this.makeToast(true, 'success', 'Autorización correcta', 'Conductor autorizado correctamente.')
          this.confirmAuth = true
          this.autorizando = false
          this.dataLoad = parseInt(this.getFranchisee)
        })
        .catch(error => {
          // console.log(error)
          if (error) {
            this.makeToast(true, 'danger', 'Error', 'Ocurrió un error, verifica que el conductor no esté autorizado y tengas conexión a internet.')
            this.autorizando = false
            this.dataLoad = parseInt(this.getFranchisee)
          }
        })
    },
    async reloadDataDrivers() {
      this.dataLoad = 0
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
  },
  created() {
    this.preferential = this.$route.params.preferential === 1
    // LOAD CATALOGS
    this.data = require(`../../../services/data/${this.getConcesionarioId.address.state}.json`)
    this.municipios = this.data[this.getConcesionarioId.address.state]
    this.codigos = this.municipios[this.getConcesionarioId.address.city]
    if (this.codigos[this.getConcesionarioId.address.postalCode]) {
      this.colonias = this.codigos[this.getConcesionarioId.address.postalCode]
    }
  },
  validations: {
    getConcesionarioId: {
      name: { required },
      email: { required, email },
      phoneNumber: { phoneNumber, required },
      rfc: { required, rfc },
      address: {
        city: { required },
        state: { required },
        extNumber: { required, alphaNum },
        intNumber: { alphaNum },
        postalCode: { required, numeric },
        suburb: { required },
        street: { required },
      },
    },
  },
}
</script>
<style>
#deshabilitado {
  color: rgb(240, 121, 9);
}
</style>
